import { action } from 'satcheljs';
export var onDeleteConversationItemPartsComplete = action('ON_DELETE_CONVERSATION_ITEM_PARTS_COMPLETE');
export var toggleRowReadStateComplete = action('TOGGLE_ROW_READ_STATE_COMPLETE');
//# sourceMappingURL=mailTriageActions.js.map